import * as React from 'react';
import { Stack } from '../../Stack';
import { jsx as _jsx } from "react/jsx-runtime";
export const SectionBody = _ref => {
  let {
    padding = '0',
    children
  } = _ref;
  const styles = {
    root: {
      padding: padding,
      margin: 0,
      height: '100%'
    }
  };
  return /*#__PURE__*/_jsx(Stack, {
    styles: styles,
    children: children
  });
};